const init = () => {
    if (document.body.clientWidth <= 320) {
        return;
    }

    document
        .querySelectorAll(".ns-cards-line__content")
        .forEach((nsCardsLineTarget) => {
            let options = {
                threshold: [0, 0.25, 0.5, 0.75, 1],
            };
            let observer = new IntersectionObserver(inView, options);

            observer.observe(nsCardsLineTarget);
            nsCardsLineTarget.addEventListener(
                "mousemove",
                transformPosition,
                true
            );
            nsCardsLineTarget.addEventListener(
                "mouseleave",
                dropTransformPosition,
                false
            );
            nsCardsLineTarget.addEventListener(
                "mousedown",
                markSwipeStart,
                false
            );
            nsCardsLineTarget.addEventListener("mouseup", markSwipeEnd, false);

            nsCardsLineTarget.addEventListener(
                "touchmove",
                transformPosition,
                true
            );
            nsCardsLineTarget.addEventListener(
                "touchstart",
                markSwipeStart,
                false
            );
            nsCardsLineTarget.addEventListener("touchend", markSwipeEnd, false);
        });
};

function transformPosition(event) {
    let clientX = event.clientX ? event.clientX : event.touches[0].clientX;
    if (
        window.swipeStartPosition &&
        event.currentTarget.clientWidth != event.currentTarget.scrollWidth
    ) {
        window.oldOffsetElement = window.offsetElement;

        if (!window.offsetElement) {
            window.offsetElement = 0;
        }

        if (!window.prevClientX) {
            window.prevClientX = clientX;
            window.offsetElement -= 1;
        } else {
            window.offsetElement -= window.prevClientX - clientX;

            if (
                event.currentTarget.scrollWidth -
                    event.currentTarget.clientWidth <
                Math.abs(window.offsetElement)
            ) {
                window.offsetElement = window.oldOffsetElement;
                return;
            }

            window.prevClientX = clientX;
        }

        event.currentTarget.style.transform = `translateX(${window.offsetElement}px)`;
    }
}

function dropTransformPosition(event) {
    event.currentTarget.style.transform = "translateX(0px)";

    delete window.swipeStartPosition;
    delete window.offsetElement;
    delete window.offsetElement;
}

function markSwipeStart(event) {
    let clientX = event.clientX ? event.clientX : event.touches[0].clientX;
    window.swipeStartPosition = clientX;
    event.currentTarget.style.transition = "0ms";
}

function markSwipeEnd(event) {
    let clientX = event.clientX
        ? event.clientX
        : event.changedTouches[0].clientX;
    if (window.swipeStartPosition === clientX) {
        let link = event.target;
        while (typeof link.href === "undefined") {
            link = link.parentNode;
            if (link === document) {
                break;
            }
        }
        if (typeof link.href !== "undefined") {
            window.location.assign(link.href);
        }
    }
    delete window.swipeStartPosition;
    delete window.prevClientX;
    event.currentTarget.style.transition = null;
}

function inView(entries) {
    entries.forEach((entry) => {
        if (!window.prevY) {
            window.prevY = entry.boundingClientRect.y;
        }
        if (
            window.prevY != entry.boundingClientRect.y &&
            !window.swipeStartPosition
        ) {
            entry.target.style.transform = "translateX(0px)";

            delete window.swipeStartPosition;
            delete window.offsetElement;
            delete window.offsetElement;
        }
        window.prevY = entry.boundingClientRect.y;
        if (entry.boundingClientRect.x === 0) {
            let actualMargin = Math.ceil(-77 + 77 * entry.intersectionRatio);

            entry.target.style.setProperty(
                "--actualMargin",
                `${actualMargin}px`
            );
        }
    });
}

window.addEventListener("DOMContentLoaded", init, false);
